import { determineRuntimeEnvironment, getBaseUrl } from "../runtime";

export const DEFAULT_UNKNOWN_ERROR =
  "An unknown error has occurred. Please try again later.";

export const getHostUrl = (): string => {
  const { environment } = determineRuntimeEnvironment(window.location.hostname);
  return getBaseUrl({
    environment,
  });
};

export const baseUrl = getHostUrl();
export const API_ENDPOINTS = {
  CNB_GENERAL_RPC: `${baseUrl}/console/api/navigation/rpc`,
};
export const CONSOLE_ZEN_REDIRECT_ROOT_PATH = "/console-zen";
export const HELP_REDIRECT_ROOT_PATH = "/help";

export const logPrefixes = {
  domain: "[Domain]",
  search: "[Search]",
};
